import React, { ReactNode } from 'react'

type TCard = {
  readonly noElevation?: boolean
  readonly children: ReactNode
}

export default function Card({ noElevation, children }: TCard) {
  return (
    <div
      className={`flex w-full flex-col gap-4 rounded-xl bg-white p-5 ${
        !noElevation && 'border shadow-md'
      }`}
    >
      {children}
    </div>
  )
}
